import * as React from 'react';

import classnames from 'classnames';

import styles from './bulleted-list.module.css';

type Bullet = React.ReactNode | string;

type Props = {
    bullets: ReadonlyArray<Bullet>;
    size: 'normal' | 'big' | 'small';
    greyBullets?: boolean;
    marginBottom?: number;
    variant?: 'errors';
    lessSpacing?: boolean;
};

export class BulletedList extends React.PureComponent<Props> {
    static defaultProps = {
        size: 'normal',
    };

    render() {
        const listStyle = classnames({
            [styles['bulleted-list--small']]: this.props.size === 'small',
            [styles['bulleted-list--normal']]: this.props.size === 'normal',
            [styles['bulleted-list--big']]: this.props.size === 'big',
        });

        const itemStyle = classnames({
            [styles['list-item--small']]: this.props.size === 'small',
            [styles['list-item--normal']]: this.props.size === 'normal',
            [styles['list-item--big']]: this.props.size === 'big',
            [styles['list-item--grey']]: this.props.greyBullets,
            [styles['list-item--errors']]: this.props.variant === 'errors',
            [styles['list-item--less-spacing']]: this.props.lessSpacing,
        });

        const marginBottom =
            typeof this.props.marginBottom === 'number' ? this.props.marginBottom : 32;

        return (
            <ul style={{marginBottom: `${marginBottom}px`}} className={listStyle}>
                {this.props.bullets.map((bullet, index) => {
                    return (
                        // eslint-disable-next-line react/no-array-index-key
                        <li key={index} className={itemStyle}>
                            {bullet}
                        </li>
                    );
                })}
            </ul>
        );
    }
}
